import Big from 'big.js';
import { DateTime } from 'luxon';
import * as hyejoo from 'smg/admin/hyejoo';
import * as models from 'smg/admin/models';
import { HasPerm, Session } from 'smg/admin/session';
import axios from 'smg/axios';
import Batch from 'smg/batch';
import { DollarFormat } from 'smg/util';
import { CacheKey, Orders } from './data';

// Orders() returns plain hyejoo JSON shapes, not models.Order class instances.
export async function KPICards(orders: Promise<hyejoo.Order[]>) {
    const now = DateTime.now();
    const session = await Session();

    const everyoneTotalYesterday = document.querySelector('#everyone-total-yesterday') as HTMLElement;
    const everyoneTotalToday = document.querySelector('#everyone-total-today') as HTMLElement;
    const smgYesterday = document.querySelector('#smg-yesterday') as HTMLElement;
    const smgToday = document.querySelector('#smg-today') as HTMLElement;
    const myTeamYesterday = document.querySelector('#my-team-yesterday') as HTMLElement;
    const yesterdayTotal = document.querySelector('#total-yesterday') as HTMLElement;
    const myTeamToday = document.querySelector('#my-team-today') as HTMLElement;
    const todayTotal = document.querySelector('#total-today') as HTMLElement;
    const myTeamThisMonth = document.querySelector('#my-team-this-month') as HTMLElement;
    const totalThisMonth = document.querySelector('#total-this-month') as HTMLElement;

    let myTeamYesterdayNum = Big(0);
    let yesterdayTotalNum = Big(0);
    let myTeamTodayNum = Big(0);
    let todayTotalNum = Big(0);
    let myTeamThisMonthNum = Big(0);
    let totalThisMonthNum = Big(0);

    let totalsPromise: Promise<models.OrderTotalsResponse> | undefined;
    if (await HasPerm('r/orders/totals')) {
        totalsPromise = axios.get('/orders/totals').then(resp => models.OrderTotalsResponse.fromJSON(resp.data));
    } else {
        everyoneTotalYesterday.closest('.col')?.remove();
        everyoneTotalToday.closest('.col')?.remove();
        smgYesterday.closest('.col')?.remove();
        smgToday.closest('.col')?.remove();
    }

    const previousWorkingDay = totalsPromise ?
        DateTime.fromISO((await totalsPromise).previousWorkingDay) :
        now.minus({ days: 1 });

    // The orders we're handed only cover the current month, so when the previous
    // working day lands in an earlier month (e.g. today is the 1st) its orders
    // have to come from that month's fetch or the yesterday cards show $0 (#498).
    let allOrders = await orders;
    if (!previousWorkingDay.hasSame(now, 'month')) {
        const b = new Batch();
        const previousMonthOrders = Orders(previousWorkingDay, false, b);
        void b.exec();
        allOrders = allOrders.concat(await (await previousMonthOrders).get(previousWorkingDay.toFormat(CacheKey)) ?? []);
    }

    for (const order of allOrders) {
        const d = DateTime.fromISO(order.pendingUpdated ?? '');
        const isYesterday = d.hasSame(previousWorkingDay, 'day');
        const isToday = d.hasSame(now, 'day');
        const isThisMonth = d.hasSame(now, 'month');

        if (isThisMonth) {
            totalThisMonthNum = totalThisMonthNum.add(order.totalSansTax || 0);
        }

        if (isYesterday) {
            yesterdayTotalNum = yesterdayTotalNum.add(order.totalSansTax || 0);
        }

        if (isToday) {
            todayTotalNum = todayTotalNum.add(order.totalSansTax || 0);
        }

        if (order.originalSalesTeamID && session.user.salesTeamUsers?.some(salesTeamUser => salesTeamUser.originalSalesTeamID === order.originalSalesTeamID)) {
            if (isThisMonth) {
                myTeamThisMonthNum = myTeamThisMonthNum.add(order.totalSansTax || 0);
            }

            if (isYesterday) {
                myTeamYesterdayNum = myTeamYesterdayNum.add(order.totalSansTax || 0);
            }

            if (isToday) {
                myTeamTodayNum = myTeamTodayNum.add(order.totalSansTax || 0);
            }
        }
    }

    myTeamYesterday.innerText = DollarFormat(myTeamYesterdayNum);
    yesterdayTotal.innerText = DollarFormat(yesterdayTotalNum);
    myTeamToday.innerText = DollarFormat(myTeamTodayNum);
    todayTotal.innerText = DollarFormat(todayTotalNum);
    myTeamThisMonth.innerText = DollarFormat(myTeamThisMonthNum);
    totalThisMonth.innerText = DollarFormat(totalThisMonthNum);

    if (!session.user.salesTeamUsers?.length) {
        (document.querySelector('#my-team-yesterday-container') as HTMLElement).classList.add('d-none');
        (document.querySelector('#my-team-today-container') as HTMLElement).classList.add('d-none');
        (document.querySelector('#my-team-this-month-container') as HTMLElement).classList.add('d-none');
    }

    if (await HasPerm('r/orders?realm=*')) {
        everyoneTotalYesterday.closest('.col')?.classList.add('d-none');
        everyoneTotalToday.closest('.col')?.classList.add('d-none');
    }

    if (totalsPromise) {
        const totals = await totalsPromise;
        everyoneTotalYesterday.innerText = DollarFormat(totals.totalYesterday);
        everyoneTotalToday.innerText = DollarFormat(totals.totalToday);
        smgYesterday.innerText = DollarFormat(totals.smgYesterday);
        smgToday.innerText = DollarFormat(totals.smgToday);
    }

    const funCardParent = document.querySelector('#fun-cards-parent');
    funCardParent?.classList.remove('d-none');
}